import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import withCSRF from '../../../commonComponents/withCSRF';
import translate from '../../../commonComponents/translate';
import { compose } from '../../../services/utilityFunctions';
import SessionProp from '../propTypes/sessionProp';
import {
  PURCHASE_STATUS,
  checkIfHasCreatorAccess,
} from '../propTypes/sessionUtils';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import ClassroomContent from './ClassroomContent';

const ClassroomSection = props => {
  /** Context */
  const { loggedUser } = useContext(LoggedUserContext);
  const loggedUserId = loggedUser?._id || null;
  /** Props */
  const {
    t,
    session,
    handleQRModal,
    handleEnrollModal,
  } = props;
  const {
    purchaseStatus,
  } = session || {};

  /** Aux */
  // Already Paid or is free or has creator access
  const hasAccessToContent =
    purchaseStatus === PURCHASE_STATUS.FREE ||
    purchaseStatus === PURCHASE_STATUS.PAID ||
    checkIfHasCreatorAccess(session, loggedUserId);

  /** Render Content */
  return (
    <>
      {hasAccessToContent ? (
        <ClassroomContent session={session} onQRModal={handleQRModal} />
      ) : (
        <span className="col-lg-12 locationBlock">
          <div className="m-portlet m-portlet--rounded m-portlet--rounded-force location-container" />
            <div className="center-btn-middle">
              <div className="button">
                <div className="session-actions">
                  <button
                    type="button"
                    onClick={handleEnrollModal}
                    className="btn btn-md m-btn--pill btn-dynamic navigation-button"
                  >
                    {t('sessions_enrollSession')}
                  </button>
                </div>
              </div>
            </div>
        </span>
      )}
    </>
  );
};

ClassroomSection.propTypes = {
  t: PropTypes.func.isRequired, // translate function
  session: PropTypes.shape(SessionProp.propType).isRequired, // session obj (state) from parent
  handleQRModal: PropTypes.func.isRequired, // handles the opening and shows the QR code in the modal
  handleEnrollModal: PropTypes.func.isRequired, // handles the opening of the purchase modal
};

export default compose(
  translate,
  withCSRF,
)(ClassroomSection);
